import { visionPoints } from "@/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export const Vision = () => (
  <section id="vision" data-testid="vision-section" className="relative py-28 border-t border-white/5">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <div className="rounded-3xl border border-brand-green/20 bg-gradient-to-b from-brand-green/[0.07] to-transparent p-10 sm:p-14 text-center">
          <Overline>Our Vision</Overline>
          <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">
            A world where <span className="text-gradient">parking just works.</span>
          </h2>
          <p className="mt-5 text-white/60 max-w-xl mx-auto">
            We turn parking into a real-time revenue engine, better for city budgets, smoother for traffic, and happier for the residents who live there.
          </p>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {visionPoints.map((v, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="rounded-xl border border-white/10 bg-ink/60 px-5 py-5 font-heading font-bold text-xl">{v}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
